import React, { Fragment } from "react";
import Button from "@material-ui/core/Button";
import Fade from "@material-ui/core/Fade";
import Icon from "@material-ui/core/Icon";
import styled from "styled-components";
import _ from "lodash";

import PrefDialog from "./PrefDialog";

const StyledFab = styled(Button)`
  && {
    background: #2196f3;
    color: #f5f5f5;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    transition: background 0.3s;
  }
  &&:hover {
    background: #43a8ff;
  }
`;
class MetricPreferenceModal extends React.Component {
  state = {
    isOpen: false,
    activeStep: 0,
    metrics: []
  };
  get maxMetricCount() {
    return 6;
  }

  componentDidMount() {
    this.resetMetrics();
  }

  componentDidUpdate(prevProps, prevState) {
    this.resetMetrics();
  }

  resetMetrics = () => {
    const { tileData } = this.props;
    const { metrics } = this.state;
    if (_.isEmpty(metrics) && !_.isEmpty(tileData)) {
      this.setState({
        metrics: _.cloneDeep(tileData)
      });
    }
  };

  openFreshModal = () => {
    this.setState({ isOpen: true, activeStep: 0, metrics: [] });
  };

  closeModal = () => {
    this.props.onClose();
    this.setState({ isOpen: false });
  };

  renderPrefDialog() {
    return (
      <PrefDialog
        isMetric={true}
        screenType={this.props.screenType}
        onClose={this.closeModal}
        isOpen={this.state.isOpen}
        prefData={this.state.metrics}
        maxCount={6}
        updateContactScreenPreferencesCallback={this.props.updateContactScreenPreferencesCallback}
      />
    );
  }

  render() {
    let { isExpanded } = this.props;

    return !isExpanded ? null : (
      <Fragment>
        {this.renderPrefDialog()}
        <Fade in={isExpanded}>
          <StyledFab
            onMouseLeave={this.props.onEditButtonLeave}
            onMouseOver={this.props.onEditButtonHover}
            onClick={this.openFreshModal}
            mini
            variant="fab"
            aria-label="Edit"
          >
            <Icon id="editIcon">edit_icon</Icon>
          </StyledFab>
        </Fade>
      </Fragment>
    );
  }
}

export default MetricPreferenceModal;
